import React from 'react'

import USA from './USA'
import UA from './UA'
import ES from './ES'
import RU from './RU'
import ZH from './ZH'
import FR from './FR'
import GB from './GB'
import AU from './AU'
import BN from './BN'
import CN from './CN'
import FJ from './FJ'
import GU from './GU'
import ID from './ID'
import JP from './JP'
import KH from './KH'
import KR from './KR'
import LK from './LK'
import LA from './LA'
import MM from './MM'
import MNP from './MNP'
import MO from './MO'
import MV from './MV'
import MY from './MY'
import NZ from './NZ'
import PG from './PG'
import PH from './PH'
import SG from './SG'
import TH from './TH'
import TW from './TW'
import VN from './VN'
import AE from './AE'
import EG from './EG'
import NG from './NG'
import PK from './PK'
import GH from './GH'
import KE from './KE'
import LB from './LB'
import MA from './MA'
import MU from './MU'
import MZ from './MZ'
import SA from './SA'
import SZ from './SZ'
import ZA from './ZA'
import DK from './DK'
import SE from './SE'

export default {
  usa: <USA />,
  en: <USA />,
  gb: <GB />,
  ua: <UA />,
  zh: <ZH />,
  ru: <RU />,
  es: <ES />,
  fr: <FR />,
  au: <AU />,
  bn: <BN />,
  cn: <CN />,
  fj: <FJ />,
  gu: <GU />,
  id: <ID />,
  jp: <JP />,
  kh: <KH />,
  kr: <KR />,
  lk: <LK />,
  la: <LA />,
  mm: <MM />,
  mnp: <MNP />,
  mo: <MO />,
  mv: <MV />,
  my: <MY />,
  nz: <NZ />,
  pg: <PG />,
  ph: <PH />,
  sg: <SG />,
  th: <TH />,
  tw: <TW />,
  vn: <VN />,
  ae: <AE />,
  eg: <EG />,
  ng: <NG />,
  pk: <PK />,
  gh: <GH />,
  ke: <KE />,
  lb: <LB />,
  ma: <MA />,
  mu: <MU />,
  mz: <MZ />,
  sa: <SA />,
  sz: <SZ />,
  za: <ZA />,
  dk: <DK />,
  se: <SE />,
}
